import React, { useEffect, useState } from 'react';
import ImageComponent from 'atoms/Image';
import { ReactSVG } from 'react-svg';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import {
  getImageClass,
  getCartFoodClassName,
  customiseEditButtonText,
  itemAccordionHeader,
  CheckForNotAvailable,
  getItemName,
  getExcludedModifiersArray,
} from 'organisms/CartPage/AU/Utils/cartPageUtils';
import { withRouter } from 'react-router-dom';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { useSelector } from 'react-redux';
import { addOnsRemoveFromCartAnalyticsData } from 'organisms/CartPage/Utils/cartPageUtils';
import { quantityIncreaseDecreaseFromCart } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { toast } from 'react-toastify';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import RemoveGiftCardModal from 'organisms/CartPage/AU/Presentation/ReusableComponents/RemoveGiftCardModal';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
const { SHOW_PDP_ALERT_POPUP } = CART_PAGE_CONSTANTS;

export const itemRemoveWrapper = ({
  isAddedPromosCoupon,
  item,
  setConfirmationModel,
  itemRemoveHandler,
  isRemoveItemLoading,
  setRemoveItem,
  sliceDispatch,
}) => {
  if (!isRemoveItemLoading) {
    toast.dark(
      <div className='img-text-div'>
        <span className={`notifyText notifyText-in`}>
          {translateWithI18Next(CART_PAGE_CONSTANTS?.TOAST_NOTIFICATION?.ITEM_REMOVED)}
        </span>
      </div>,
      {
        bodyClassName: 'toast-for-favorite',
        hideProgressBar: true,
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: true,
      },
    );
    isAddedPromosCoupon ? setConfirmationModel(item) : itemRemoveHandler(item, setRemoveItem);
    sliceDispatch(setPWAstorage({ key: SHOW_PDP_ALERT_POPUP, value: false }));
  }
};
export const removeCouponHandler = ({ item, setCartItem, setCouponModal, sliceDispatch }) => {
  setCouponModal(true);
  setCartItem(item);
  sliceDispatch(setPWAstorage({ key: SHOW_PDP_ALERT_POPUP, value: false }));
};
export const getPaperBagFeeClassName = enablepaperBag => (enablepaperBag ? 'get-paper-bag-fee' : '');

export const getPaperBagFee = enablepaperBag => (enablepaperBag ? 'paper-bag-fee' : '');

export const getItemsBasedOnSelection = (isMobile, item, isCustom) =>
  isMobile ? item : { ...item, foodName: itemAccordionHeader(isCustom) };

export const getScheduledTimeCheck = (item, timeBasedCetegory, timeBasedAlertModalData) => {
  return (
    item?.categoryUrl === timeBasedCetegory?.url &&
    timeBasedCetegory?.isTimeExpired &&
    (timeBasedAlertModalData?.isBrowseMenuOrReviewOrderCTAClicked ||
      (timeBasedAlertModalData?.title === START_ORDER_CONSTANTS?.CART_REVIEW_ORDER_MODAL &&
        timeBasedAlertModalData?.isCloseButtonClicked))
  );
};

const FoodItemListCard = props => {
  const {
    contentData,
    isMobile,
    tenantReducer,
    itemCustomiseHandler,
    itemRemoveHandler,
    getQuantityPrice,
    flatResponse,
    history,
    dispositionType,
    promosApplied,
    disCountLinesItems,
    setConfirmationModel,
    isRemoveItemLoading,
    timeBasedCetegory,
    timeBasedAlertModalData,
    discountAmounts,
    paymentDiscountAmounts,
    productMapByItemId,
  } = props;
  const itemNotAvailableAtStoreMsg = tenantReducer?.componentOptions?.web?.global?.itemNotAvailableAtStoreMsg;
  const { ANALYTICS_EVENTS, REMOVE_ITEM } = CART_PAGE_CONSTANTS;
  const { REMOVE, CUSTOM, PROMO_TEXT } = TRANSLATE_MAPPING_KEY;
  const { Promos_Coupon_Icon } = IMAGE_PATH;
  const cartReducer = useSelector(data => data.cartReducer);
  const sliceDispatch = useAppDispatch();
  const exclusionsDetails = useSelector(({ menuReducer: { exclusionsResponse } }) => exclusionsResponse);
  const [removeItem, setRemoveItem] = useState([]);
  const [couponModal, setCouponModal] = useState(false);
  const [cartItem, setCartItem] = useState({});

  useEffect(() => {
    if (cartReducer?.cartData?.removedAddOnItems?.length > 0 || cartReducer?.itemRemove) {
      const itemObj =
        cartReducer?.cartData?.removedAddOnItems?.length > 0 &&
        addOnsRemoveFromCartAnalyticsData(cartReducer?.cartData, productMapByItemId, discountAmounts);
      let itemValue = removeItem?.length > 0 ? [...removeItem] : [];
      if (itemObj) {
        itemValue = [...itemValue, ...itemObj];
      }
      (itemObj || itemValue) &&
        cartReducer?.itemRemove &&
        quantityIncreaseDecreaseFromCart(ANALYTICS_EVENTS.REMOVE, itemValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartReducer?.cartData?.removedAddOnItems, cartReducer?.itemRemove, removeItem]);

  const checkProductPromo = foodItemId => {
    const promoItem = promosApplied && filterPromoItem(foodItemId);
    return promoItem?.length > 0;
  };
  const setMaxQuantity = foodItemId => {
    const promoItem = promosApplied && filterPromoItem(foodItemId);
    if (promoItem?.length > 0) {
      return promoItem?.[0]?.max;
    }
    return false;
  };
  const filterPromoItem = foodItemId => {
    let findPromoItem = false;
    disCountLinesItems?.forEach(item => {
      findPromoItem = item?.itemPromo?.filter(promo => promo?.itemId === foodItemId);
    });
    return findPromoItem;
  };

  return (
    <>
      {contentData?.map(item => {
        const enablepaperBag = item?.name === START_ORDER_CONSTANTS?.PAPER_BAG_FEE;
        const isCustom = item?.custom;
        const { discountComponents } = item;
        const isAddedFromCoupon = discountComponents?.length > 0;
        const isAddedPromosCoupon = item?.isProductPromo ? checkProductPromo(item?.foodItemId) : false;
        const accordionHeader = getItemsBasedOnSelection(isMobile, item, isCustom);
        item.maxQuantity = setMaxQuantity(item?.foodItemId);
        const excludedModifiersData = getExcludedModifiersArray(item?.modifiers, exclusionsDetails);
        const isItemExcluded = exclusionsDetails?.filter(excludedItem => excludedItem?.itemId === item?.foodItemId);
        const isScheduledTimePassed = getScheduledTimeCheck(item, timeBasedCetegory, timeBasedAlertModalData);
        //* once data comes in exclution API, then no need of this line */
        if (!item?.toRemove && isScheduledTimePassed) {
          item.toRemove = true;
        }
        return (
          <div
            key={item?.foodItemId}
            className={`${getCartFoodClassName(item?.toRemove)} 
          ${getPaperBagFeeClassName(enablepaperBag)} cart-card-mobile`}
          >
            <div className='cart-image-container' style={item?.imageData?.backgroundsrc}>
              <ImageComponent
                srcFile={item?.imageData?.src}
                altText={item?.imageData?.altText}
                className={getImageClass(item?.toRemove)}
              />
            </div>
            <div className={`${getPaperBagFee(enablepaperBag)} cart-food-content-parent-container`}>
              {!isMobile && (
                <div className='cart-food-card-item-name'>
                  {isAddedPromosCoupon && (
                    <span className='cart-coupon-link'>
                      <ReactSVG src={Promos_Coupon_Icon} alt='' className='cart-offers-icon' />
                      <span className='cart-coupon-text'>{PROMO_TEXT}</span>
                    </span>
                  )}
                  {item?.foodName}
                </div>
              )}
              <div className='cart-food-card-customise-details'>
                <div className='cart-food-card-customised'>
                  {isAddedPromosCoupon && (
                    <span className='cart-coupon-link'>
                      <ReactSVG src={Promos_Coupon_Icon} alt='' className='cart-offers-icon' />
                      <span className='cart-coupon-text'>{PROMO_TEXT}</span>
                    </span>
                  )}
                  {getItemName(item, accordionHeader, tenantReducer, isCustom)}
                </div>
                <div className='cart-food-card-details'>
                  {isCustom && <div className='cart-food-card-custom-tag'>{translateWithI18Next(CUSTOM)}</div>}
                  <div className='cart-food-card-quantity-modifier'>
                    {getQuantityPrice(item, isAddedFromCoupon, paymentDiscountAmounts)}
                  </div>
                </div>
              </div>
              {!enablepaperBag && (
                <div className='cart-food-card-item-edit-remove'>
                  {!isItemExcluded?.length &&
                  !isScheduledTimePassed &&
                  (!item?.toRemove || excludedModifiersData?.length) ? (
                    <span
                      className='cart-food-edit'
                      data-testid='cart-food-edit'
                      onClick={() => itemCustomiseHandler(flatResponse, item, history, dispositionType, sliceDispatch)}
                    >
                      {customiseEditButtonText(isCustom)}
                    </span>
                  ) : null}
                  {!item?.freeItem && (
                    <span
                      tabIndex='0'
                      aria-label='do you want to remove the above itams'
                      className='cart-food-remove'
                      data-testid='cart-food-remove'
                      onClick={() =>
                        paymentDiscountAmounts?.length
                          ? removeCouponHandler({ item, setCartItem, setCouponModal, sliceDispatch })
                          : itemRemoveWrapper({
                              isAddedPromosCoupon,
                              item,
                              setConfirmationModel,
                              itemRemoveHandler,
                              isRemoveItemLoading,
                              setRemoveItem,
                              sliceDispatch,
                            })
                      }
                    >
                      {translateWithI18Next(REMOVE)}
                    </span>
                  )}
                </div>
              )}
            </div>
            <CheckForNotAvailable
              isRemove={item?.toRemove}
              dispositionType={dispositionType}
              itemNotAvailableAtStoreMsg={itemNotAvailableAtStoreMsg}
            />
            <div className='cart-food-card-quantity-modifier-mobile'>
              <hr />
              {getQuantityPrice(item, isAddedFromCoupon)}
              <CheckForNotAvailable isRemove={item?.toRemove} dispositionType={dispositionType} />
              {couponModal && (
                <RemoveGiftCardModal
                  isAddedPromosCoupon={isAddedFromCoupon}
                  cartItem={cartItem}
                  setConfirmationModel={setConfirmationModel}
                  itemRemoveHandler={itemRemoveHandler}
                  isRemoveItemLoading={isRemoveItemLoading}
                  setCouponModal={setCouponModal}
                  setRemoveItem={setRemoveItem}
                  itemCustomiseHandler={itemCustomiseHandler}
                  flag={REMOVE_ITEM}
                  itemRemoveWrapper={itemRemoveWrapper}
                />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default withRouter(FoodItemListCard);
